import { isNull } from '@aloft/toolkit-shared';

import { makeRowID } from './makeRowID.ts';

type ScrollBlock = 'start' | 'center' | 'end' | 'nearest';

export const scrollToIndex = (index: number, block: ScrollBlock = 'center') => {
  const rowElementID = makeRowID(index);
  const element = document.querySelector(`#${CSS.escape(rowElementID)}`);
  if (isNull(element)) {
    console.error(`Could not find element with ID: ${rowElementID}`);
    return;
  }
  element.scrollIntoView({ block, behavior: 'instant' });
};
